module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_career-172d65b883eecaca8a9563247aea0a65.svg";